{register} = require 'src/js/infrastructure/setup-registry'
{FacilityController} = require './facility-controller'

ViewSetup = (ctx) ->
    view = ctx.find '#facility-view'
    ctrl = new FacilityController view
    return ctrl

register 'App.RealEstate.Facility.ViewSetup', ViewSetup
